module.exports = __webpack_public_path__ + "static/media/nic.d6219933.jpeg";